import { render } from "./Selected.vue?vue&type=template&id=5f97fa6a&bindings={\"program\":\"options\",\"questionsConfig\":\"options\",\"selection\":\"options\",\"loaded\":\"options\",\"showSponsoringTable\":\"options\",\"formattedDate\":\"options\",\"trackPrintView\":\"options\"}"
import script from "./Selected.vue?vue&type=script&lang=js"
export * from "./Selected.vue?vue&type=script&lang=js"
script.render = render

export default script